/** Do not edit this file, it is automatically generated **/
import React, { PropsWithChildren } from "react";
import styled from "styled-components";

import Icon, { IconProps } from "./Icon";

const IconTrashLineComponent: React.FC<PropsWithChildren<IconProps>> & { DataUrl: string; Content: string; } = (props) => {
return (
  <Icon {...props} viewBox="0 0 512 512">
    <><g>
    <g>
        <g>
            <polygon points="353.574,176.526 313.496,175.056 304.807,412.34 344.885,413.804" />
            <rect x="235.948" y="175.791" width="40.104" height="237.285" />
            <polygon points="207.186,412.334 198.497,175.049 158.419,176.52 167.109,413.804" />
            <path d="M17.379,76.867v40.104h41.789L92.32,493.706C93.229,504.059,101.899,512,112.292,512h286.74 c10.394,0,19.07-7.947,19.972-18.301l33.153-376.728h42.464V76.867H17.379z M380.665,471.896H130.654L99.426,116.971h312.474 L380.665,471.896z">
            </path>
        </g>
    </g>
</g>
<g>
    <g>
        <path d="M321.504,0H190.496c-18.428,0-33.42,14.992-33.42,33.42v63.499h40.104V40.104h117.64v56.815h40.104V33.42 C354.924,14.992,339.932,0,321.504,0z">
        </path>
    </g>
</g></>
  </Icon>
);
};

IconTrashLineComponent.DataUrl = "data:image/svg+xml;charset=utf-8;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8Zz4KICAgIDxnPgogICAgICA8Zz4KICAgICAgICA8cG9seWdvbiBwb2ludHM9IjM1My41NzQsMTc2LjUyNiAzMTMuNDk2LDE3NS4wNTYgMzA0LjgwNyw0MTIuMzQgMzQ0Ljg4NSw0MTMuODA0Ii8+CiAgICAgICAgPHJlY3QgeD0iMjM1Ljk0OCIgeT0iMTc1Ljc5MSIgd2lkdGg9IjQwLjEwNCIgaGVpZ2h0PSIyMzcuMjg1Ii8+CiAgICAgICAgPHBvbHlnb24gcG9pbnRzPSIyMDcuMTg2LDQxMi4zMzQgMTk4LjQ5NywxNzUuMDQ5IDE1OC40MTksMTc2LjUyIDE2Ny4xMDksNDEzLjgwNCIvPgogICAgICAgIDxwYXRoIGQ9Ik0xNy4zNzksNzYuODY3djQwLjEwNGg0MS43ODlMOTIuMzIsNDkzLjcwNkM5My4yMjksNTA0LjA1OSwxMDEuODk5LDUxMiwxMTIuMjkyLDUxMmgyODYuNzQgYzEwLjM5NCwwLDE5LjA3LTcuOTQ3LDE5Ljk3Mi0xOC4zMDFsMzMuMTUzLTM3Ni43MjhoNDIuNDY0Vjc2Ljg2N0gxNy4zNzl6IE0zODAuNjY1LDQ3MS44OTZIMTMwLjY1NEw5OS40MjYsMTE2Ljk3MWgzMTIuNDc0IEwzODAuNjY1LDQ3MS44OTZ6Ij4KICAgICAgICA8L3BhdGg+CiAgICAgIDwvZz4KICAgIDwvZz4KICA8L2c+CiAgPGc+CiAgICA8Zz4KICAgICAgPHBhdGggZD0iTTMyMS41MDQsMEgxOTAuNDk2Yy0xOC40MjgsMC0zMy40MiwxNC45OTItMzMuNDIsMzMuNDJ2NjMuNDk5aDQwLjEwNFY0MC4xMDRoMTE3LjY0djU2LjgxNWg0MC4xMDRWMzMuNDIgQzM1NC45MjQsMTQuOTkyLDMzOS45MzIsMCwzMjEuNTA0LDB6Ij4KICAgICAgPC9wYXRoPgogICAgPC9nPgogIDwvZz4KPC9zdmc+";
IconTrashLineComponent.Content = `<svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
  <g>
    <g>
      <g>
        <polygon points="353.574,176.526 313.496,175.056 304.807,412.34 344.885,413.804"/>
        <rect x="235.948" y="175.791" width="40.104" height="237.285"/>
        <polygon points="207.186,412.334 198.497,175.049 158.419,176.52 167.109,413.804"/>
        <path d="M17.379,76.867v40.104h41.789L92.32,493.706C93.229,504.059,101.899,512,112.292,512h286.74 c10.394,0,19.07-7.947,19.972-18.301l33.153-376.728h42.464V76.867H17.379z M380.665,471.896H130.654L99.426,116.971h312.474 L380.665,471.896z">
        </path>
      </g>
    </g>
  </g>
  <g>
    <g>
      <path d="M321.504,0H190.496c-18.428,0-33.42,14.992-33.42,33.42v63.499h40.104V40.104h117.64v56.815h40.104V33.42 C354.924,14.992,339.932,0,321.504,0z">
      </path>
    </g>
  </g>
</svg>`;

const IconTrashLine = styled(IconTrashLineComponent)``;

export default IconTrashLine;
